export const AI_CHATS_CHANGED_EVENT = "writeme:ai-chats-changed";
